import React, { useEffect, useMemo, useState } from 'react';
import { publicAPI } from './services/api';
import './PaymentResult.css';

interface ContactSettings {
  hotel_name: string;
  contact_phone: string;
  contact_email: string;
  address: string;
}

const PaymentFail: React.FC = () => {
  const [contactSettings, setContactSettings] = useState<ContactSettings | null>(null);

  useEffect(() => {
    publicAPI.getGeneralSettings()
      .then((res) => {
        if (res.data.success && res.data.data) {
          const data = res.data.data;
          // API bazen ayarı { key, value } formatında döndürüyor.
          setContactSettings(data.value || data);
        }
      })
      .catch((err) => {
        console.error('Settings yüklenemedi:', err);
      });
  }, []);

  const displayPhone = contactSettings?.contact_phone?.trim() || '0(5XX) XXX XX XX';
  const telHref = useMemo(() => {
    const phone = contactSettings?.contact_phone || '';
    const digits = phone.replace(/\D/g, '');

    if (!digits) {
      return 'tel:+905XXXXXXXXX';
    }

    if (digits.startsWith('0')) {
      return `tel:+9${digits}`;
    }

    if (digits.startsWith('90')) {
      return `tel:+${digits}`;
    }

    if (digits.length === 10) {
      return `tel:+90${digits}`;
    }

    return `tel:+${digits}`;
  }, [contactSettings?.contact_phone]);

  return (
    <div className="payment-result-page">
      <div className="payment-result-container fail">
        <div className="fail-icon">
          <div className="crossmark">✕</div>
        </div>
        
        <h1>Ödeme Başarısız</h1>
        
        <p className="result-message">
          Üzgünüz, ödeme işlemi tamamlanamadı.
        </p>
        
        <div className="info-box error">
          <p><strong>Olası Sebepler:</strong></p>
          <ul>
            <li>Kart bilgileriniz hatalı olabilir</li>
            <li>Kartınızda yeterli bakiye olmayabilir</li>
            <li>İşlem limitiniz aşılmış olabilir</li>
            <li>3D Secure doğrulaması başarısız olmuş olabilir</li>
          </ul>
        </div>
        
        <div className="action-buttons">
          <button 
            className="btn-try-again"
            onClick={() => window.location.hash = '#reservation'}
          >
            Tekrar Dene
          </button>
          
          <button 
            className="btn-return-home"
            onClick={() => window.location.hash = '#home'}
          >
            Ana Sayfaya Dön
          </button>
        </div>
        
        <p className="help-text">
          Sorun devam ederse lütfen bankanızla iletişime geçin veya 
          bizimle iletişime geçmek için <a href={telHref}>{displayPhone}</a> numaralı telefonu arayın.
        </p>
      </div>
    </div>
  );
};

export default PaymentFail;
